import React from "react"
import { Dialog, Transition } from "@headlessui/react"
import { Fragment } from "react"
import { XMarkIcon, NoSymbolIcon } from "@heroicons/react/24/outline"
import CancelledPatientCard from "./CancelledPatientCard"

const CancelledPatientsPopup = ({
	isOpen,
	onClose,
	cancelledPatients,
	nurseSchedule,
	chairSchedule
}) => {
	// Sort the cancelled patients by scheduledStartTime
	const sortedPatients = [...cancelledPatients].sort((a, b) => {
		return a.scheduledStartTime - b.scheduledStartTime
	})

	if (sortedPatients.length === 0) {
		return null
	}

	return (
		<Transition appear show={isOpen} as={Fragment}>
			<Dialog as="div" className="relative z-[100]" onClose={onClose}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className="fixed inset-0 bg-black bg-opacity-25" />
				</Transition.Child>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<Dialog.Panel className="w-full max-w-4xl transform overflow-auto rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all max-h-[90vh] my-auto mx-auto">
								<div className="flex justify-between items-center mb-4">
									<Dialog.Title
										as="h3"
										className="text-lg font-bold leading-6 text-gray-900 flex items-center"
									>
										<span className="text-red-500 mr-2">
											<NoSymbolIcon className="h-6 w-6" aria-hidden="true" />
										</span>
										Newly Cancelled Patients
									</Dialog.Title>
									<button
										type="button"
										className="flex items-center gap-1.5 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-semibold text-gray-600 hover:bg-gray-100 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-300"
										onClick={onClose}
									>
										<XMarkIcon className="h-5 w-5" aria-hidden="true" />
										Close
									</button>
								</div>

								<div className="mt-2">
									{/* Table-like header - using exactly the same structure as card */}
									<div className="p-3 bg-gray-100 rounded-t-lg mb-2">
										<div className="flex items-center">
											<div className="w-[200px] font-medium text-gray-800 text-left">
												Patient
											</div>
											<div className="w-[160px] font-medium text-gray-800 text-left">
												Nurse
											</div>
											<div className="w-[130px] font-medium text-gray-800 text-left">
												Treatment
											</div>
											<div className="w-[100px] font-medium text-gray-800 text-left">
												Time
											</div>
											<div className="w-[100px] font-medium text-gray-800 text-left">
												Chair
											</div>
										</div>
									</div>

									{/* List of patient cards */}
									<div className="space-y-1">
										{sortedPatients.map(patient => {
											const nurseName = nurseSchedule.find(
												nurse => nurse.nurseId === patient.assignedNurse
											)?.nurseName
											const chairName = chairSchedule.find(
												chair => chair.chairId === patient.assignedChair
											)?.chairName

											return (
												<CancelledPatientCard
													key={patient.patientId}
													patient={patient}
													nurseName={nurseName}
													chairName={chairName}
												/>
											)
										})}
									</div>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition>
	)
}

export default CancelledPatientsPopup
